<template>
  <ion-menu
    class="SideMenu"
    side="end"
    type="overlay"
    menu-id="mainMenu"
    content-id="main"
  >
    <div class="SideMenu_content">
      <ion-header class="SideMenu_header">
        <ion-toolbar>
          <p class="SideMenu_title">{{$t('SideMenu.menuTitle')}}  {{ store.state.user.login }}</p>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list class="SideMenu_itemList">

          <ion-item
          class="SideMenu_item"
            button
            :detail="false"
            @click="handleHomeClick"
          >
            <ion-icon :icon="homeOutline" slot="start"></ion-icon>
            <ion-label>{{$t('SideMenu.home')}}</ion-label>
          </ion-item>

          <ion-item
            class="SideMenu_item is-admin"
            v-if="isAdminEnabled"
            button
            :detail="false"
            @click="handleAdminClick"
          >
            <ion-icon :icon="newspaperOutline" slot="start"></ion-icon>
            <ion-label>{{$t('SideMenu.admin')}} <span class="SideMenu_desktopOnly">({{ $t('SideMenu.desktopOnly') }})</span></ion-label>
          </ion-item>
          <ion-item v-if="isAdminEnabled">
            <ion-label>{{$t('SideMenu.mode')}} <span class="SideMenu_desktopOnly">({{ $t('SideMenu.desktopOnly') }})</span></ion-label>
            <ion-toggle  v-model="isMaintenance" @click="handleSwitchMode" @toggle="handleSwitchMode" :on-ion-change="handleSwitchMode"></ion-toggle>
          </ion-item>

          <ion-item
            class="SideMenu_item"
            button
            :detail="false"
            @click="handleLogoutClick"
          >
            <ion-icon :icon="logOutOutline" slot="start"></ion-icon>
            <ion-label>{{$t('SideMenu.logout')}}</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </div>
  </ion-menu>
</template>

<script lang="ts">
import {
  IonMenu,
  IonToolbar,
  IonHeader,
  IonItem,
  IonList,
  IonContent,
  IonIcon,
  IonLabel,
  IonToggle,
  menuController,
} from '@ionic/vue';
import { computed, defineComponent, watch } from 'vue';
import { useStore } from 'vuex';
import { logOutOutline, newspaperOutline, homeOutline } from 'ionicons/icons';
import actions from '../store/actions';
import router from '@/router/index';

export default defineComponent({
  name: 'SideMenu',
  components: {
    IonMenu,
    IonContent,
    IonList,
    IonItem,
    IonHeader,
    IonToolbar,
    IonIcon,
    IonLabel,
    IonToggle
  },
  setup() {
    const store = useStore();

    let isMaintenance = store.getters.isMaintenanceMode;

    const handleLogoutClick = () => {
      actions.logout();
    };
    const handleAdminClick = () => {
      router.push('/admin');
    };
    const handleHomeClick = () => {
      router.push('/home');
    }
    const handleSwitchMode = function (value: any) {
      const currentValue = !value.target.checked
      actions.changeMaintenanceMode(currentValue).then((value) => {
        isMaintenance = value
      })

    }

    // auto close menu when route changes
    watch(router.currentRoute, () => {
      setTimeout(() => {
        menuController.close('mainMenu');
      }, 600)
    });

    return {
      store,
      logOutOutline,
      newspaperOutline,
      homeOutline,
      handleLogoutClick,
      handleAdminClick,
      handleHomeClick,
      handleSwitchMode,
      isMaintenance,
      isAdminEnabled: computed(() => store.getters.isAdmin),
    }
  },
});
</script>
<style lang="scss">
.SideMenu {
  --background: rgba(10, 19, 31, 0.85);
  color: #fff;
  *,
  .item.sc-ion-label-ios-h,
  .item .sc-ion-label-ios-h {
    color: #fff;
  }
}

.SideMenu_title {
  text-align: center;
  font-weight: 500;
}

.SideMenu_header {
  ion-toolbar {
    --background: transparent;
  }
}
.SideMenu_content {
  height: 100%;
}

.SideMenu_itemList {
  --ion-item-border-color: rgba(255, 255, 255, 0.33);
  --ion-item-background: transparent;
}

.SideMenu_item {
  transition: all .15s;
  &:last-child {
    --ion-item-border-color: transparent;
  }
  &:hover {
    background: rgba(0, 0, 0, 0.2);
  }
  &.is-admin {
    @media screen and (max-width: 960px) {
      pointer-events: none;
      opacity: 0.5;
    }
  }
}
.SideMenu_desktopOnly {
  display: none;
  @media screen and (max-width: 960px) {
    display: inline;
  }
}
</style>
